<template>
    <div class="form-content-wrapper">
        <div v-if="hasAccess" class="action-browse-wrapper">
            <b-form-file v-model="input" name="fotoBarangPendukung" :state="Boolean(foto)"
                drop-placeholder="Drop file here..." accept=".jpg, .png, .jpeg" @input="browseFile()">
            </b-form-file>
            <b-button variant="cancelBtn">
                <i class="fa fa-upload mr-2"></i>
                Upload Foto
            </b-button>
        </div>

        <b-button v-if="hasAccess" variant="pgiBtn" class="mb-2" :disabled="isSubmitting" name="closeDetailBtn"
            @click="inputFotoLink">
            {{ isSubmitting ? 'Loading...' : 'Upload Foto dari Link' }}
        </b-button>

        <b-table bordered hover show-empty :fields="fields" :busy="isBusy" :items="data.photos" responsive class="mb-3">

            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Loading data...</strong>
                </div>
            </template>
            <template v-slot:empty>
                Tidak ada data.
            </template>
            <template v-slot:cell(foto)="row">
                <a v-bind:href="$companyId == 'PGI' ? $baseFilePath + row.item.name : row.item.name" target="_blank">
                    <img width="130px" height="130px"
                        :src="$companyId == 'PGI' ? $baseFilePath + row.item.name : row.item.name">
                </a>
            </template>
            <template v-if="hasAccess" v-slot:cell(aksi)="row">
                <b-button class="btn btn-sm" variant="danger" @click="confirmDeleteFoto(row.item.id)">
                    <i class="fa fa-trash"></i>
                </b-button>
            </template>
        </b-table>

        <ModalConfirm id="confirm-hapus-foto" title="Konfirmasi hapus Foto" :isSubmitting="isBusy"
            desc="Apakah anda yakin untuk menghapus foto ini?" @submit="onDeleteFoto()" />

        <b-modal id="modal-loading" centered size="sm" hide-footer hide-header no-close-on-esc no-close-on-backdrop>
            <h4 class="text-center text-lg">LOADING ...</h4>
        </b-modal>

        <b-modal id="modal-input-foto-link" title="Upload Foto dari Link" centered size="md" no-close-on-esc
            no-close-on-backdrop>
            Link Foto
            <b-input v-model="linkFoto" maxlength="200" />
            <template #modal-footer>
                <div class="">
                    <b-button variant="pgiBtn" class="ml-2" @click="submitFotoLink" :disabled="isSubmitting">
                        <i class="fa fa-print mr-2"></i>
                        {{ isSubmitting ? "Loading..." : "Submit" }}
                    </b-button>
                </div>
            </template>
        </b-modal>

    </div>
</template>

<script>

export default {
    props: {
        data: {
            type: Object,
            required: true
        },
        idTipe: {
            type: Number,
            default: null
        },
        hasAccess: {
            type: Boolean,
            required: true
        }
    },
    components: {

    },
    data() {
        return {
            id: null,
            initStatus: 0,
            isSubmitting: false,
            isBusy: true,

            linkFoto: null,
            tipeBarang: null,
            activeId: null,
            activeId: null,
            foto: [],
            input: null,

            fields: [
                { key: "foto", label: "Foto" },
                { key: "aksi", label: "Aksi" }
            ],
        }
    },
    methods: {
        init() {
            this.initStatus = 0
            this.initStatus = 1
            this.toggleBusy()
            // this.id = (this.idTipe != null) ? this.idTipe : this.$route.params.id

            // let getSingleTipeBarang = this.$axios.get(`barang-tipe-v2/${this.id}`).then(response => {
            //     this.tipeBarang = response.data
            //     this.foto = response.data.foto
            //     let msg = this.$helper.getFlash()
            //     this.toggleBusy()
            //     this.$helper.toastSucc(this, msg)
            // })

            // Promise.all([getSingleTipeBarang]).then(() => {
            //     this.initStatus = 1
            // })
            //     .catch(error => {
            //         console.log(error)
            //         this.initStatus = -1
            //     })

        },
        async fetchData() {
            await this.$emit('fetchData', this.data.id)
        },

        confirmDeleteFoto(id) {
            this.activeId = id
            this.$bvModal.show("confirm-hapus-foto")
        },

        onDeleteFoto() {
            this.isSubmitting = true
            this.$bvModal.show("modal-loading")
            this.$axios.post(`/imei-check/delete-photo?photoId=` + this.activeId).then(response => {

                this.$bvModal.hide("confirm-hapus-foto")
                this.$helper.toastSucc(this, 'Data berhasil dihapus')
                this.fetchData()
                this.$bvModal.hide("modal-loading")
                this.isSubmitting = false
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.$bvModal.hide("modal-loading")
                    this.isSubmitting = false
                })
        },

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        browseFile() {
            this.$bvModal.show("modal-loading")
            let formData = new FormData();

            formData.append('id', this.data.id);
            formData.append('photo', this.input);

            this.$axios.post(`imei-check/insert-photo`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                this.fetchData()
                this.$helper.toastSucc(this, "foto berhasil diupload!")
                this.$bvModal.hide("modal-loading")
            }).catch(error => {
                // Tindakan jika terjadi kesalahan
                console.log(error);
                this.initStatus = -1;
                this.$bvModal.hide("modal-loading")
            });
        },

        inputFotoLink() {
            this.$bvModal.show("modal-input-foto-link")
            this.linkFoto = null
        },

        submitFotoLink() {
            if (this.linkFoto == null) {
                return this.$helper.toastErr(this, "Form tidak boleh kosong!")
            }

            this.isSubmitting = true
            let payload = new FormData()
            payload.append('id', this.data.id);
            payload.append("link", this.linkFoto)
            this.$axios.post(`/imei-check/insert-photo-via-link`, payload).then(response => {
                this.fetchData()
                this.$helper.toastSucc(this, "foto berhasil diupload!")
                this.$bvModal.hide("modal-loading")
                this.$bvModal.hide("modal-input-foto-link")
                this.linkFoto == null
                this.isSubmitting = false
            }).catch(error => {
                // Tindakan jika terjadi kesalahan
                console.log(error);
                this.initStatus = -1;
                this.$bvModal.hide("modal-loading")
                this.isSubmitting = false
            });
        }

    },
    watch: {

        //----------------- Pantau Filter Jenis Barang -----------------

        linkFoto: function (newValue) {
            let cleanValue = newValue.replace(/\s+/g, ''); // Menghapus semua spasi
            this.$nextTick(() => this.linkFoto = cleanValue);
        }
    },
    created() {
        this.init()
    }
}
</script>